import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {

    users: [],
    usersCacheExpires: null,
    usersLoading: false,
    usersLoadError: {msg: null, code: null},

    roles: [],
    rolesLoading: false,
    rolesLoadedTime: null,
    permissions: [],

    pendingInvitations: [],
    pendingInvitationsLoading: false,
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

